import React from 'react';
import { motion } from 'framer-motion';
const EASE = [0.23, 1, 0.32, 1] as const;
interface RevealProps {
  children: React.ReactNode;
  /** Stagger index — 60ms apart. */
  delay?: number;
  y?: number;
  className?: string;
  style?: React.CSSProperties;
}
export function Reveal({
  children,
  delay = 0,
  y = 14,
  className = '',
  style
}: RevealProps) {
  return <motion.div initial={{
    opacity: 0,
    y
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.3,
    ease: EASE,
    delay
  }} className={className} style={style} data-id="element-548" data-mp="1ksx5fl276kye">
      {children}
    </motion.div>;
}
export function Eyebrow({
  children
}: {
  children: React.ReactNode;
}) {
  return <span className="block text-[12px] font-semibold uppercase tracking-[0.34em] text-vexu-600" data-id="element-549" data-mp="17224qw1ura5w">
      {children}
    </span>;
}
export function Hairline({
  className = ''
}: {
  className?: string;
}) {
  return <div className={`h-px w-full bg-slate-900/[0.10] ${className}`} data-id="element-550" data-mp="x32tr6tm72fq" />;
}